// src/components/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";

export default function Footer({ t }) {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-10 border-t border-slate-200/60 dark:border-slate-700/60">
      <div className="max-w-6xl mx-auto px-4 py-6">
        {/* Row 1: nav / contact (left) */}
        <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-sm">
          <Link
            to="/about"
            className="text-sky-600 hover:text-sky-700 dark:text-sky-400 dark:hover:text-sky-300 underline-offset-4 hover:underline"
          >
            {t("footerAbout")}
          </Link>

          <span className="text-slate-400 dark:text-slate-600">·</span>

          <Link
            to="/blog"
            className="text-sky-600 hover:text-sky-700 dark:text-sky-400 dark:hover:text-sky-300 underline-offset-4 hover:underline"
          >
            {t("blogNav")}
          </Link>

          <span className="text-slate-400 dark:text-slate-600">·</span>

          <Link
            to="/terms"
            className="text-sky-600 hover:text-sky-700 dark:text-sky-400 dark:hover:text-sky-300 underline-offset-4 hover:underline"
          >
            {t("footerTerms")}
          </Link>

          <span className="text-slate-400 dark:text-slate-600">·</span>

          <Link
            to="/privacy"
            className="text-sky-600 hover:text-sky-700 dark:text-sky-400 dark:hover:text-sky-300 underline-offset-4 hover:underline"
          >
            {t("footerPrivacy")}
          </Link>

          <span className="text-slate-400 dark:text-slate-600">·</span>

          <Link
            to="/refund"
            className="text-sky-600 hover:text-sky-700 dark:text-sky-400 dark:hover:text-sky-300 underline-offset-4 hover:underline"
          >
            {t("footerRefund")}
          </Link>

          <span className="text-slate-400 dark:text-slate-600">·</span>

          <Link
            to="/pricing-info"
            className="text-sky-600 hover:text-sky-700 dark:text-sky-400 dark:hover:text-sky-300 underline-offset-4 hover:underline"
          >
            {t("footerPricing")}
          </Link>

          <span className="text-slate-400 dark:text-slate-600">·</span>

          <Link
            to="/winter-route"
            className="text-sky-600 hover:text-sky-700 dark:text-sky-400 dark:hover:text-sky-300 underline-offset-4 hover:underline"
          >
            {t("footerWinterRoute")}
          </Link>

          <span className="text-slate-400 dark:text-slate-600">·</span>
          <a
            href="mailto:hello@eltumvedrid.is"
            className="text-sky-600 hover:text-sky-700 dark:text-sky-400 dark:hover:text-sky-300 underline-offset-4 hover:underline"
          >
            {t("footerContact")}: hello@eltumvedrid.is
          </a>
        </div>

        {/* Row 2: attribution (subtle) */}
        <div className="mt-2 text-xs text-slate-500 dark:text-slate-400">
          © {year} Eltum Veðrið · {t("footerDataBy")}{" "}
          <a
            href="https://open-meteo.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-slate-600 hover:text-slate-800 dark:text-slate-300 dark:hover:text-slate-100 underline-offset-4 hover:underline"
          >
            Open-Meteo
          </a>
        </div>

        {/* Row 3: funding acknowledgement */}
        <div className="mt-1 text-xs text-slate-500 dark:text-slate-400">
          {t("footerSupport")}
        </div>
      </div>
    </footer>
  );
}
